import React from 'react';
import Navbar    from './components/Navbar';
import Footer    from './components/Footer';
import ScrollTop from './components/ScrollTop';
import Hero    from './pages/Hero';
import WhyUs   from './pages/WhyUs';
import Courses  from './pages/Courses';
import Batches  from './pages/Batches';
import Stories  from './pages/Stories';
import Notices  from './pages/Notices';
import Videos   from './pages/Videos';
import Apply    from './pages/Apply';

const GLOBAL_CSS = `
  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  html { scroll-behavior: smooth; font-size: 16px; }
  body {
    font-family: 'DM Sans', sans-serif;
    background: #FFF8F4;
    color: #0D1B2A;
    overflow-x: hidden;
    -webkit-font-smoothing: antialiased;
  }
  img { display: block; max-width: 100%; }
  a { text-decoration: none; }
  button { font-family: inherit; }

  ::-webkit-scrollbar { width: 5px; }
  ::-webkit-scrollbar-track { background: #F5EFE8; }
  ::-webkit-scrollbar-thumb { background: #BC002D60; border-radius: 3px; }

  @keyframes petal-fall {
    0%   { transform: translateY(-20px) rotate(0deg)   translateX(0);    opacity: 0.7; }
    100% { transform: translateY(110vh) rotate(720deg) translateX(80px);  opacity: 0; }
  }
  .sk-petal {
    position: fixed; pointer-events: none; z-index: 0;
    width: 9px; height: 9px;
    border-radius: 50% 0 50% 0;
    background: #F9C0CB;
    animation: petal-fall linear infinite;
  }

  @keyframes floatY {
    0%, 100% { transform: translateY(0); }
    50%       { transform: translateY(-12px); }
  }

  @keyframes pulse-dot {
    0%, 100% { transform: scale(1);   opacity: 1; }
    50%       { transform: scale(1.4); opacity: 0.7; }
  }

  .sk-fade-up {
    opacity: 0;
    transform: translateY(28px);
    transition: opacity 0.65s ease, transform 0.65s ease;
  }
  .sk-fade-up.sk-visible { opacity: 1; transform: translateY(0); }

  .sk-card-hover { transition: transform 0.22s ease, box-shadow 0.22s ease; }
  .sk-card-hover:hover { transform: translateY(-6px); box-shadow: 0 20px 56px rgba(13,27,42,0.13); }

  input, select, textarea {
    font-family: 'DM Sans', sans-serif;
    font-size: 15px; width: 100%;
    padding: 14px 18px;
    border: 1.5px solid #E0D8D0;
    border-radius: 6px;
    background: white; color: #0D1B2A;
    outline: none;
    transition: border-color 0.2s, box-shadow 0.2s;
  }
  input:focus, select:focus, textarea:focus {
    border-color: #BC002D;
    box-shadow: 0 0 0 3px rgba(188,0,45,0.12);
  }
  label {
    font-size: 13px; font-weight: 600;
    color: rgba(13,27,42,0.75); letter-spacing: 0.04em;
    display: block; margin-bottom: 7px;
    font-family: 'Syne', sans-serif;
  }
`;

function Sakura() {
  const petals = Array.from({ length: 9 }, (_, i) => ({
    left: `${4 + i * 11}%`, delay: `${i * 1.9}s`,
    duration: `${9 + (i % 3) * 2.5}s`, size: `${8 + (i % 4) * 2.5}px`,
  }));
  return (
    <>
      {petals.map((p, i) => (
        <div key={i} className="sk-petal" style={{
          left: p.left, top: '-20px', width: p.size, height: p.size,
          animationDuration: p.duration, animationDelay: p.delay, opacity: 0.55,
        }} />
      ))}
    </>
  );
}

export default function App() {
  return (
    <>
      <style>{GLOBAL_CSS}</style>
      <Sakura />
      <Navbar />
      <main>
        <Hero />
        <WhyUs />
        <Courses />
        <Batches />
        <Stories />
        <Notices />
        <Videos />
        <Apply />
      </main>
      <Footer />
      <ScrollTop />
    </>
  );
}
